export default __webpack_public_path__ + "static/media/human.e976c9c4.svg";